// src/components/CalendarScheduler.js
import React, { useState } from 'react';
import { updatePlace, deletePlace } from '../services/tripService';
import PlaceCard from './PlaceCard';
import './CalendarScheduler.css';

const CalendarScheduler = ({ trip, places, editMode, onUpdate, isOwner = true }) => {
  const [selectedDate, setSelectedDate] = useState(new Date(trip.start_date));

  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };

  const getDatesInRange = () => {
    const dates = [];
    const start = new Date(trip.start_date);
    const end = new Date(trip.end_date);
    
    for (let date = new Date(start); date <= end; date.setDate(date.getDate() + 1)) {
      dates.push(new Date(date));
    }
    
    return dates;
  };

  const getPlacesForDate = (date) => {
    const dateStr = formatDate(date);
    return places.filter(place => {
      if (!place.start_time) return false;
      const placeDate = new Date(place.start_time).toISOString().split('T')[0];
      return placeDate === dateStr;
    }).sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
  };

  const handleUpdatePlace = async (placeId, updates) => {
    try {
      await updatePlace(trip.id, placeId, updates);
      onUpdate();
    } catch (error) {
      console.error('Error updating place:', error);
      alert('更新景點失敗');
    }
  };

  const handleDeletePlace = async (placeId) => {
    if (window.confirm('確定要刪除這個景點嗎？')) {
      try {
        await deletePlace(trip.id, placeId);
        onUpdate();
      } catch (error) {
        console.error('Error deleting place:', error);
        alert('刪除景點失敗');
      }
    }
  };

  const dates = getDatesInRange();

  return (
    <div className="calendar-scheduler">
      <div className="calendar-header">
        <h2>行程安排</h2>
        {editMode && isOwner && (
          <div className="edit-notice">
            編輯模式：點擊景點進行修改
          </div>
        )}
        {!isOwner && (
          <div className="view-notice">
            瀏覽模式：查看 {trip.title} 的行程安排
          </div>
        )}
      </div>

      <div className="calendar-view">
        <div className="dates-nav">
          {dates.map((date, index) => {
            const isSelected = formatDate(date) === formatDate(selectedDate);
            const dayPlaces = getPlacesForDate(date);
            
            return (
              <button
                key={index}
                onClick={() => setSelectedDate(date)}
                className={`date-nav-btn ${isSelected ? 'active' : ''}`}
              >
                <div className="date-info">
                  <span className="day-name">
                    {date.toLocaleDateString('zh-TW', { weekday: 'short' })}
                  </span>
                  <span className="date-number">
                    {date.getDate()}
                  </span>
                  <span className="month-year">
                    {date.toLocaleDateString('zh-TW', { month: 'short' })}
                  </span>
                </div>
                {dayPlaces.length > 0 && (
                  <div className="places-count">
                    {dayPlaces.length} 個景點
                  </div>
                )}
              </button>
            );
          })}
        </div>

        <div className="selected-date-content">
          <div className="date-header">
            <h3>
              {selectedDate.toLocaleDateString('zh-TW', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric',
                weekday: 'long'
              })}
            </h3>
          </div>

          <div className="places-timeline">
            {getPlacesForDate(selectedDate).length === 0 ? (
              <div className="no-places">
                <p>這一天還沒有安排景點</p>
                {editMode && isOwner && (
                  <p className="edit-hint">使用「新增景點」按鈕來添加景點</p>
                )}
              </div>
            ) : (
              <div className="places-list">
                {getPlacesForDate(selectedDate).map(place => (
                  <PlaceCard
                    key={place.id}
                    place={place}
                    editMode={editMode && isOwner} // 只有擁有者才能編輯
                    onUpdate={isOwner ? handleUpdatePlace : null} // 只有擁有者才能更新
                    onDelete={isOwner ? handleDeletePlace : null} // 只有擁有者才能刪除
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarScheduler;